<template>
  <div class="page">
    <div class="video_box">
      <a-carousel arrows class="swiper-pc">
        <div slot="prevArrow" slot-scope="props" class="custom-slick-arrow" style="left: 10px; zindex: 1">
          <a-icon type="left-circle" />
        </div>
        <div slot="nextArrow" slot-scope="props" class="custom-slick-arrow" style="right: 10px">
          <a-icon type="right-circle" />
        </div>
        <div class="video_wra">
          <video src="https://ow-resource.gousii.com/video/%E9%A6%96%E9%A1%B5banner-%E7%AC%AC%E4%B8%80%E5%BC%A0.mov"
            class="video" loop muted autoplay preload object-fit="cover" x-webkit-airplay="true" airplay="allow"
            webkit-playsinline="true" playsinline="true"></video>
          <div class="title">智慧数字应用解决方案提供商</div>
          <div class="subtitle">
            提供一站式、定制化智慧服务，覆盖商业、园区、公寓与零售等热门领域
            <br />
            构卓品质 <span style="padding: 0 4px"></span>思和共赢
          </div>
        </div>
        <div class="banner-box" :style="{ background: `url(${item.url})` }" v-for="item in bannerList"
          :key="item.title">
          <div class="title">{{ item.title }}</div>
          <div class="subtitle">
            {{ item.desc1 }}
            <br />
            {{ item.desc2 }}
          </div>
        </div>
      </a-carousel>
      <div class="swiper-mobile">
        <a-carousel autoplay>
          <img v-for="item in mobileBannerList" :key="item" :src="item" alt="" />
        </a-carousel>
      </div>
    </div>
    <div class="solution">
      <h1>提供专业化定制解决方案</h1>
      <p>
        深耕商业和资产管理、智慧园区、智慧公寓、智慧零售等领域
      </p>
      <solution-item></solution-item>
      <div class="solution-box">
        <h1>一次投入永久使用 支持源码合作和二次开发</h1>
        <p>独立部署更安全 定制服务更灵活 托管服务更省心</p>
        <solution-component></solution-component>
      </div>
    </div>

    <div class="product">
      <h1>提供定制化解决方案，构建全面一站式智慧商业平台</h1>
      <p>按需定制、全业务流程调研、多角色功能实现</p>
    </div>
    <div class="home-solution">
      <home-solution></home-solution>
    </div>

    <div class="product">
      <h1>PMS租房服务升级，智慧租赁住房解决方案</h1>
      <p>按需定制，覆盖长短租业务全场景服务</p>
    </div>
    <div class="home-solution">
      <home-solution :contentType="1"></home-solution>
    </div>
    <div class="bi">
      <h1>BI数据大屏</h1>
      <p>
        打造清晰、直观、透明的公寓管理可视化平台，整合各项数据。实时监测入住率、查看代办事项和服务，对合同、资产进行全方面的管理，全面提升公寓的运营效率。
      </p>
      <a-carousel :arrows="mob">
        <div slot="prevArrow" slot-scope="props" class="custom-slick-arrow" style="left: 10px; zindex: 1">
          <a-icon type="left-circle" />
        </div>
        <div slot="nextArrow" slot-scope="props" class="custom-slick-arrow" style="right: 10px">
          <a-icon type="right-circle" />
        </div>
        <div v-for="(item, index) in biData" :key="index">
          <div class="bi-img">
            <img :src="item.src" alt="" />
          </div>
        </div>
      </a-carousel>
    </div>
    <div class="device">
      <h1>构建智能化管理的物联网解决方案</h1>
      <p>深度整合业务场景，为各类房源提供安全合规管理支持</p>
      <div class="items">
        <div class="item" v-for="item in deviceList" :key="item.title">
          <div class="title">{{ item.title }}</div>
          <div class="subtitle">{{ item.subtitle }}</div>
          <img :src="item.src" alt="">
        </div>
      </div>
    </div>
    <div class="news">
      <div class="news_con">
        <h1>多维度服务案例 全场景智慧生态</h1>
        <service-case />
      </div>
    </div>
    <div class="partner">
      <div class="partner_con">
        <h1>点滴纪录 我们服务过的企业</h1>
        <service-enterprise :start="0" :end="6" />
        <service-enterprise :direction="2" :start="6" :end="12" />
        <service-enterprise :start="12" :end="17" />
        <img class="mask" src="@/assets/image/enterprise/mask.png" alt="" />
        <img class="mask right" src="@/assets/image/enterprise/mask.png" alt="" />
      </div>
    </div>
  </div>
</template>

<script>
import SolutionComponent from "../components/SolutionComponent";
import SolutionItem from "../components/SolutionItem";
import homeSolution from "../components/homeSolution";
import ServiceCase from "@/components/ServiceCase.vue";
import ServiceEnterprise from "@/components/ServiceEnterprise.vue";
export default {
  name: "HomePage",
  components: {
    SolutionComponent,
    SolutionItem,
    ServiceCase,
    ServiceEnterprise,
    homeSolution,
  },
  data() {
    return {
      mobileBannerList: [
        'https://ow-resource.gousii.com/image%2F%E7%A7%BB%E5%8A%A8%E7%AB%AFbanner-%E5%85%AC%E5%8F%B8%E4%BB%8B%E7%BB%8D.jpg',
        'https://ow-resource.gousii.com/image%2Fmobile-banner1.png',
        'https://ow-resource.gousii.com/image%2Fmobile-banner3.jpg',
        'https://ow-resource.gousii.com/image%2Fmobile-banner2.png',
        'https://ow-resource.gousii.com/image%2F%E7%A7%BB%E5%8A%A8%E7%AB%AF%E9%A6%96%E9%A1%B5-%E9%9B%B6%E5%94%AE.jpg'
      ],
      current: 1,
      bannerList: [
        {
          title: '数智驱动，商业全域优化',
          desc1: '融合物联网、大数据、AI等创新技术，用数字驱动运营推出定制化解决方案，构建全面的一站式智慧商业平台。',
          desc2: '全面助力商业数字化和智慧化的转型升级',
          url: 'https://ow-resource.gousii.com/image%2F%E9%A6%96%E9%A1%B5banner-%E6%99%BA%E6%85%A7%E5%95%86%E4%B8%9A.png',
        },
        {
          title: '数字化赋能，租房服务智能化升级',
          desc1: '基于智能系统，提供房源查询、在线预约、签约支付等一站式租房服务。',
          desc2: '构建高效、智能的租房体系，实现高效、便捷、舒适的租房体验',
          url: 'https://ow-resource.gousii.com/image%2F%E9%A6%96%E9%A1%B5banner-%E6%99%BA%E6%85%A7%E5%85%AC%E5%AF%93.png',

        },
        {
          title: '利用IOT物联网大数据模型助力园区管理',
          desc1: '运用IOT物联网、人工智能、大数据、云计算等前沿技术，场景化解决园区日常的管理动作',
          desc2: '为园区数智化服务打造坚实的基础',
          url: 'https://ow-resource.gousii.com/image%2F%E9%A6%96%E9%A1%B5banner-%E6%99%BA%E6%85%A7%E5%9B%AD%E5%8C%BA.png',

        },
        {
          title: '数字化赋能零售，全域运营优化升级',
          desc1: '提供收银、ERP、门店、采购、库存、商城、供应链管理一体化的解决方案',
          desc2: '实现线上线下商城门店一体化，快速提高门店效益',
          url: 'https://ow-resource.gousii.com/image%2F%E9%A6%96%E9%A1%B5banner-%E6%99%BA%E6%85%A7%E9%9B%B6%E5%94%AE.png',
        },
      ],
      deviceList: [
        {
          title: "门锁门禁",
          subtitle: "远程控制，多重认证，提升安全性。",
          src: "https://ow-resource.gousii.com/image/device1.png",
        },
        {
          title: "水电燃气",
          subtitle: "智能抄表，实时监控，优化资源管理。",
          src: "https://ow-resource.gousii.com/image/device2.png",
        },
        {
          title: "车辆/人行闸道",
          subtitle: "自动识别，快速通行，提升停车效率。",
          src: "https://ow-resource.gousii.com/image/device5.png",
        },
        {
          title: "客流监控",
          subtitle: "人流量统计，行为分析，市场洞察。",
          src: "https://ow-resource.gousii.com/image/device4.png",
        },
        {
          title: "巡更安防",
          subtitle: "定时巡检，异常报警，保障区域安全。",
          src: "https://ow-resource.gousii.com/image/device3.png",
        },
      ],
      items: [
        {
          key: 1,
          title: "PMS管理系统",
          subtitle: "全生态系统提升效能",
        },
        {
          key: 2,
          title: "租客微信H5",
          subtitle: "一键转发 让品牌自由传播",
        },
        {
          key: 3,
          title: "租客小程序",
          subtitle: "轻松找到房源入口",
        },
        {
          key: 4,
          title: "PC端独立官网",
          subtitle: "打造独立的品牌形象",
        },
      ],
      listData: [
        {
          src: "https://ow-resource.gousii.com/image/partner/logo_01.png",
          name: "中国银行",
        },
        {
          src: "https://ow-resource.gousii.com/image/partner/logo_02.png",
          name: "中粮集团",
        },
        {
          src: "https://ow-resource.gousii.com/image/partner/logo_03.png",
          name: "中海地产",
        },
        {
          src: "https://ow-resource.gousii.com/image/partner/logo_21.png",
          name: "中国联通",
        },
        {
          src: "https://ow-resource.gousii.com/image/partner/logo_20.png",
          name: "中国雄安集团",
        },
        {
          src: "https://ow-resource.gousii.com/image/partner/logo_05.png",
          name: "合景泰富",
        },
        {
          src: "https://ow-resource.gousii.com/image/partner/logo_04.png",
          name: "龙湖冠寓",
        },
        {
          src: "https://ow-resource.gousii.com/image/partner/logo_23.png",
          name: "紫金和寓",
        },
        {
          src: "https://ow-resource.gousii.com/image/partner/logo_06.png",
          name: "金地物业",
        },
        {
          src: "https://ow-resource.gousii.com/image/partner/logo_07.png",
          name: "东龙控股",
        },
        {
          src: "https://ow-resource.gousii.com/image/partner/logo_24.png",
          name: "顺丰速运",
        },
        {
          src: "https://ow-resource.gousii.com/image/partner/logo_16.png",
          name: "太极计算机",
        },
        {
          src: "https://ow-resource.gousii.com/image/partner/logo_25.png",
          name: "格力集团",
        },
        {
          src: "https://ow-resource.gousii.com/image/partner/logo_09.png",
          name: "新沂城投",
        },
        {
          src: "https://ow-resource.gousii.com/image/partner/logo_17.png",
          name: "亚新物业",
        },
        {
          src: "https://ow-resource.gousii.com/image/partner/logo_27.png",
          name: "兴海物联",
        },
        {
          src: "https://ow-resource.gousii.com/image/partner/logo_22.png",
          name: "联发集团",
        },
        {
          src: "https://ow-resource.gousii.com/image/partner/logo_26.png",
          name: "诚志海图",
        },
        {
          src: "https://ow-resource.gousii.com/image/partner/logo_18.png",
          name: "邦代物业",
        },
        {
          src: "https://ow-resource.gousii.com/image/partner/logo_19.png",
          name: "保定人才公寓",
        },
        {
          src: "https://ow-resource.gousii.com/image/partner/logo_08.png",
          name: "康桥集团",
        },
      ],
      classOption: {
        limitMoveNum: 2,
        direction: 3,
      },
      list: [],
      biData: [
        { src: 'https://ow-resource.gousii.com/image/bi4.png' },
      ],
      // biData: [],
      mob: false,
    };
  },
  methods: {
    goToDetail(i) {
      //linkType=2，是外链地址
      if (i.linkType == 2) {
        window.open(i.content);
      } else {
        this.$router.push({ name: "details", params: { id: i.id } });
      }
    },
    handleActive(key) {
      this.current = key;
    },
    handleClick(key) {
      this.$router.push({ name: "product", params: { key: key } });
    },
    callback(key) {
      this.current = key;
    },
    // async getList() {
    //   const params = {
    //     pageSize: 3,
    //     pageNo: 1,
    //     status: 1,
    //   };
    //   const res = await getNews(params);
    //   if (res.data.status.code == 200) {
    //     this.list = res.data.result;
    //   }
    // },
    biInit() {
      const ids = [
        "",
        "F0c5",
        "C0c5",
        "B0c5",
        "A0c5",
        "z0c5",
        "y0c5",
        "x0c5",
        "w0c5",
      ];
      for (let i = 1; i < 9; i++) {
        this.biData.push({
          url: `https://biconfig.yxpms.com/#/third/${ids[i]}`,
          src: `https://ow-resource.gousii.com/image/bi/${i}.png`,
        });
      }
    },
    openBi(value) {
      window.open(value);
    },
  },
  created() {
    if (document.body.clientWidth > 768) {
      this.listData.splice(this.listData.length - 1, 1);
      this.mob = true;
    }
    // this.getList();
    // this.biInit();
  },
  mounted() {
    // console.log("iframe", document.getElementById("iframe"));
  },
};
</script>

<style lang="less" scoped>
.video_box {
  height: 41vw;
  width: 100%;
  position: relative;
  overflow: hidden;

  .video_wra {
    width: 100%;
    height: 41vw;
    overflow: hidden;
    position: relative;
  }

  .video {
    width: 1920px;
    // height: 100%;
    position: absolute;
    top: -290px;
    left: 50%;
    margin-left: -960px;
    z-index: 1;
    filter: brightness(60%);
  }

  .title {
    width: 100%;
    color: #fff;
    font-size: 46px;
    text-align: center;
    position: absolute;
    top: 40%;
    left: 0;
    z-index: 100;
    letter-spacing: 10px;
  }

  .subtitle {
    width: 100%;
    color: #fff;
    font-size: 20px;
    position: absolute;
    top: 52%;
    left: 0;
    text-align: center;
    z-index: 100;
    line-height: 40px;
  }

  .ty_btn {
    width: 150px;
    height: 40px;
    line-height: 40px;
    background-color: #fff;
    color: #1b55e9;
    font-size: 20px;
    border-radius: 20px;
    text-align: center;
    margin-top: 20px;
  }

  .title_wra {
    width: 1400px;
    margin: 0 auto;
    height: 100%;
    display: flex;

    .title_left {
      position: relative;
      width: 550px;
      height: 100%;
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      color: #fff;
      font-size: 20px;
    }

    .img-right {
      flex: 1;
      display: flex;
      flex-direction: column;
      justify-content: flex-end;
      align-items: flex-end;

      img {
        width: 80%;
      }
    }
  }

  .banner-box {
    width: 100%;
    height: 41vw;
    background-repeat: no-repeat !important;
    background-size: cover !important;
    position: relative;

    .title {
      width: 100%;
      color: #fff;
      font-size: 46px;
      text-align: center;
      position: absolute;
      top: 40%;
      left: 0;
      z-index: 100;
      letter-spacing: 10px;
    }

    .subtitle {
      width: 100%;
      color: #fff;
      font-size: 20px;
      position: absolute;
      top: 52%;
      left: 0;
      text-align: center;
      z-index: 100;
      line-height: 40px;
    }
  }

  .swiper-mobile {
    display: none;
    margin-top: 50px;
  }
}

.solution {
  .solution-box {
    background-color: #f5f7fa;
    margin-top: 80px;
    padding-bottom: 80px;
  }

  h1 {
    padding-top: 60px;
    text-align: center;
    color: #0d2a42;
    margin-bottom: 5px;
  }

  p {
    font-size: 16px;
    text-align: center;
    color: rgba(0, 0, 0, 0.59);
    margin-bottom: 2em;
  }
}

.product {
  text-align: center;
  margin-bottom: 20px;

  h1 {
    padding-top: 60px;
    text-align: center;
    color: #0d2a42;
    margin-bottom: 5px;
  }

  p {
    font-size: 16px;
    text-align: center;
    color: rgba(0, 0, 0, 0.59);
    margin-bottom: 2em;
  }
}

.shows {
  height: 780px;
  background-color: #1b1f26;

  .shows_con {
    position: relative;
    width: 1440px;
    margin: 0 auto;

    ul {
      padding-left: 100px;
      width: 360px;
      overflow: hidden;

      li {
        list-style: none;
        position: relative;
        padding: 0 30px;
        margin-top: 100px;
        cursor: pointer;
        transition: all 0.3s linear;

        &:before {
          display: block;
          content: "";
          width: 6px;
          height: 60px;
          background-color: transparent;
          position: absolute;
          top: 0;
          left: 0;
        }

        h2 {
          color: #76797c;
          font-size: 20px;
        }

        h3 {
          color: #76797c;
          font-size: 16px;
        }
      }

      .is_active {
        transform: translateX(20px);

        h2,
        h3 {
          color: #fff;
        }

        &:before {
          background-color: #0167ff;
        }
      }
    }

    .shows_tabs {
      display: none;
    }

    .img_con {
      width: 950px;
      position: absolute;
      right: 0;
      top: 0;

      .img_wra {
        display: inline-block;
        position: relative;
        cursor: pointer;

        .half {
          width: 475px;
        }

        .full {
          width: 950px;
        }

        h2 {
          position: absolute;
          left: 20px;
          bottom: 30px;
          color: #fff;
          font-size: 24px;
          transition: all 0.3s linear;
        }

        h3 {
          position: absolute;
          left: 20px;
          bottom: 0;
          color: #fff;
          font-size: 16px;
          opacity: 0;
          transition: all 0.3s linear;
        }

        &:hover {

          h2,
          h3 {
            transform: translateY(-40px);
          }

          h3 {
            opacity: 1;
          }
        }
      }
    }
  }
}

.bi {
  text-align: center;

  h1 {
    padding-top: 60px;
  }

  p {
    width: 750px;
    font-size: 16px;
    text-align: center;
    color: rgba(0, 0, 0, 0.59);
    margin: 0 auto 2em;
  }

  .ant-carousel {
    font-size: 0;
    width: 1200px;
    margin: 0 auto;
  }

  .bi-img {

    // background-color: #1B1F26;
    img {
      width: 1200px;
      height: auto;
      vertical-align: top;
      cursor: pointer;
      // width: 100%;
      // height: 600px;
      // object-fit: contain;
    }
  }

  iframe {
    width: 1200px;
    min-height: 680px;
    border: none;
  }
}

.news {
  .news_con {
    width: 1200px;
    margin: 0 auto;
    padding-bottom: 40px;
    overflow: hidden;

    // .ant-col {
    //   cursor: pointer;
    //   img {
    //     transition: all 0.3s ease;
    //   }
    //   &:hover {
    //     img {
    //       box-shadow: 0 4px 10px 2px rgba(48, 48, 48, 0.3);
    //     }
    //     .news_info {
    //       color: #0087fd;
    //     }
    //   }
    // }
    h1 {
      padding-top: 60px;
      text-align: center;
      color: #0d2a42;
      margin-bottom: 35px;
    }

    // p {
    //   font-size: 16px;
    //   text-align: center;
    //   color: rgba(0, 0, 0, 0.59);
    //   margin-bottom: 2em;
    // }
    // .news_time {
    //   margin-top: 10px;
    //   color: #555;
    // }
    // .news_info {
    //   color: #333;
    //   width: 345px;
    //   margin: 0 auto;
    //   white-space: nowrap;
    //   text-overflow: ellipsis;
    //   overflow: hidden;
    //   transition: color 0.3s ease;
    // }
  }
}

.device {
  width: 1200px;
  margin: 0 auto;
  text-align: center;

  h1 {
    margin: 60px 0 0;
    font-size: 28px;
    font-weight: 600;
  }

  p {
    margin: 4px 0 0;
    font-size: 16px;
    font-weight: 400;
    color: rgba(0, 0, 0, .59);
  }

  .items {
    margin-top: 36px;
    display: flex;
    flex-wrap: wrap;

    .item {
      flex: 1;
      background-color: #f1f5fd;
      padding: 20px;
      cursor: pointer;
      margin-left: 4px;

      &:hover {
        transform: scale(1.01);
        transition: all .2s linear;
        box-shadow: 0 0 15px 0 rgba(157, 178, 222, .7)
      }

      .title {
        font-size: 20px !important;
        font-weight: 700;
        margin-top: 12px;
      }

      .subtitle {
        font-size: 14px !important;
        color: #607499;
        margin-top: 6px;
      }

      img {
        margin-top: 46px;
        width: 100%;
        -webkit-user-select: none;
        -moz-user-select: none;
        user-select: none;
      }
    }
  }
}

.partner {
  // background-color: #f5f7fa;
  padding-top: 50px;

  .partner_con {
    width: 1200px;
    margin: 0 auto;
    padding-bottom: 50px;
    overflow: hidden;
    position: relative;

    .mask {
      position: absolute;
      top: 0;
      width: 8%;
      height: 100%;
      object-fit: cover;
    }

    .right {
      right: 0;
      transform: rotate(180deg);
    }

    h1 {
      text-align: center;
      color: #0d2a42;
      margin-bottom: 35px;
    }

    p {
      font-size: 16px;
      text-align: center;
      color: rgba(0, 0, 0, 0.59);
      margin-bottom: 2em;
    }
  }

  .warp {
    width: 1200px;
    height: 120px;
    margin: 0 auto;
    overflow: hidden;

    .img_con {
      display: flex;

      img {
        width: 220px;
        margin-right: 20px;
      }
    }
  }

  .item_con {
    display: inline-block;
    width: 20%;
    padding: 0 10px;
    box-sizing: border-box;

    img {
      width: 100%;
      height: 105px;
    }

    p {
      margin-top: 10px;
    }
  }
}

.ant-carousel /deep/ .slick-slide {
  text-align: center;
  // background: #364d79;
  overflow: hidden;
}

.ant-carousel /deep/ .custom-slick-arrow {
  width: 40px;
  height: 40px;
  font-size: 40px;
  color: #fff;
  opacity: 0.3;
}

.ant-carousel /deep/ .custom-slick-arrow:before {
  display: none;
}

.ant-carousel /deep/ .custom-slick-arrow:hover {
  opacity: 0.7;
}

/deep/ .ant-carousel .slick-dots-bottom {
  bottom: 30px;

  li {
    margin: 0 5px;

    button {
      height: 6px;
      border-radius: 3px;
    }
  }
}

@media screen and (max-width: 768px) {
  .page {
    width: 100vw;
    overflow: hidden;
  }

  h1 {
    font-size: 26px;
  }

  p {
    font-size: 12px !important;
  }

  .title {
    font-size: 20px !important;
  }

  .subtitle {
    font-size: 16px !important;
    top: 45% !important;
  }

  .banner2,
  .banner3 {
    display: none;
  }

  .video_box {
    height: auto;

    .swiper-mobile {
      display: block;

      img {
        width: 100%;
      }

      /deep/ .ant-carousel .slick-dots-bottom {
        bottom: 10px;
      }
    }

    .swiper-pc {
      display: none;
    }
  }

  .shows {
    height: 100vw;

    .shows_con {
      width: 100vw;

      ul {
        display: none;
      }

      .shows_tabs {
        margin: 0 auto;
        padding-top: 10px;
        display: block;
        color: #fff;

        /deep/ .ant-tabs-bar {
          border-bottom: none;
        }

        /deep/ .ant-tabs-tab {
          margin: 0 !important;
          padding: 12px 0 !important;
          width: 25vw;
          text-align: center;
        }
      }

      .img_con {
        width: 100vw;
        top: unset;

        .img_wra {
          .half {
            width: 50vw;
          }

          .full {
            width: 100vw;
            height: auto;
          }

          h2 {
            font-size: 16px;
            transition: none;
          }

          h3 {
            display: none;
          }

          &:hover {

            h2,
            h3 {
              transform: none;
            }
          }
        }
      }
    }
  }

  .bi {
    p {
      width: 90vw !important;
    }

    .ant-carousel {
      width: 100%;
    }

    .bi-img {
      img {
        width: 100%;
        // height: 300px;
      }
    }

    iframe {
      width: 100%;
      min-height: 432px;
    }
  }

  .news_con {
    width: 100vw !important;
    // .ant-col {
    //   width: 100%;
    //   text-align: center;
    // }
  }

  .device {
    width: auto;

    .items {
      margin: 36px 2px 0;
      display: flex;
      flex-wrap: wrap;

      .item {
        flex: initial;
        width: ~"calc(33.33% - 4px)";
        margin: 2px !important;
        padding: 8px 2px;

        &:first-child {
          width: ~"calc(66.66% - 4px)"
        }

        img {
          margin-top: 16px;
          width: auto;
          height: 100px
        }
      }
    }
  }

  .partner {
    .partner_con {
      width: 100vw;

      .warp {
        display: none;
      }

      .item_con {
        width: 33.3%;

        img {
          height: auto;
        }
      }
    }
  }
}

.home-solution {
  width: 1200px;
  margin: 0 auto;
}

@media screen and (max-width: 420px) {
  .bi {
    iframe {
      height: 100vh;
      // min-height: 227px;
    }
  }

  .home-solution {
    // display: none;
  }
}
</style>
